var r;!function(r){r.PrimaryAxis="primary-axis",r.SecondaryAxis="secondary-axis"}(r||(r={}));var a=Symbol.for("ChartPlotSeriesOnAxisShower");export{a as I,r as P};
